import {
  ChangeDetectionStrategy,
  Component, DoCheck,
  Input, OnChanges, SimpleChanges, ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";

require('./planning-reports-table.scss');
@Component({
  standalone: false,
  selector: 'app-planning-reports-table',
  templateUrl: './planning-reports-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningReportsTableComponent implements DoCheck {

  @Input() reports: any[];


  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  constructor() {
  }


  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }

}
